import { render, staticRenderFns } from "./holddollar-dialog.vue?vue&type=template&id=228077b3&scoped=true&"
import script from "./holddollar-dialog.vue?vue&type=script&lang=js&"
export * from "./holddollar-dialog.vue?vue&type=script&lang=js&"
import style0 from "./holddollar-dialog.vue?vue&type=style&index=0&id=228077b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228077b3",
  null
  
)

export default component.exports